/**
 * useEngineOutputs (P172) -- the Engine activity ledger: recent sealed
 * Engine outputs from the ENGINE_OUTPUT_CHAIN, newest-first. Admin-gated.
 */
import { useQuery, type UseQueryResult } from "@tanstack/react-query";

import { api, type ApiError } from "shared/api/client";
import type { EngineOutputRow } from "shared/api/types";

export function useEngineOutputs(
  limit = 50,
): UseQueryResult<EngineOutputRow[], ApiError> {
  return useQuery({
    queryKey: ["admin", "engine-outputs", limit],
    queryFn: () =>
      api.get<EngineOutputRow[]>(`/v1/admin/engine-outputs?limit=${limit}`),
  });
}
